/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';
import type { TuteurGridDto } from './TuteurGridDto';
import {
    TuteurGridDtoFromJSON,
    TuteurGridDtoFromJSONTyped,
    TuteurGridDtoToJSON,
} from './TuteurGridDto';

/**
 * 
 * @export
 * @interface TuteurGridDtoPaginatedResults
 */
export interface TuteurGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof TuteurGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<TuteurGridDto>}
     * @memberof TuteurGridDtoPaginatedResults
     */
    results?: Array<TuteurGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof TuteurGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the TuteurGridDtoPaginatedResults interface.
 */
export function instanceOfTuteurGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TuteurGridDtoPaginatedResultsFromJSON(json: any): TuteurGridDtoPaginatedResults {
    return TuteurGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function TuteurGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): TuteurGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(TuteurGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function TuteurGridDtoPaginatedResultsToJSON(value?: TuteurGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(TuteurGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

